module.exports = __webpack_public_path__ + "static/media/ic-collaborer.d0db95f3.svg";